<mat-card *ngIf="invest && invest.simulation">
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{ 'invest.simulation.title.shortLabel' | translate }} : {{ invest.simulation.name.shortLabel }}
                <app-tooltip [text]="'invest.simulation.title.summary' | translate"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <app-sic-datatable *ngIf="invest.simulation.provider !== providerType.bbc"
            [invest]="invest"></app-sic-datatable>
        <app-bbc-datatable *ngIf="invest.simulation.provider === providerType.bbc"
            [simulation]="invest.simulation"></app-bbc-datatable>
    </mat-card-content>
</mat-card>
